const CompanyDetails = () => import("./company-details/index");
const SmsSettings = () => import("./sms-settings/index");
const MenuAuthorization = () => import("./menu-auth/index");
const EtimSetup = () => import("./etims-setup");

export default [
  {
    path: "/company-details",
    component: CompanyDetails,
  },
  {
    path: "/sms-settings",
    component: SmsSettings,
  },
  {
    path: "/menu-authorization",
    component: MenuAuthorization,
  },
  {
    path: "/etims-setup",
    component: EtimSetup,
  },
];
